import { Depth, InstallationSequence } from "../panels/panelParameters";

export enum PanelType {
    Window = "Window",
    Straight = "Straight",
    Corner = "Corner",
    Atypical = "Atypical",
}

export enum PanelCategory {
    Panel = "Panel",
    Corner = "Corner",
    CustomPanel = "CustomPanel",
    CustomCorner = "CustomCorner",
    CustomZShapedPanel = "CustomZShapedPanel",
}

export type PanelListCommonElement = {
    id: string;
    number?: number;
    installationSequence: InstallationSequence;
    depthMm: Depth;
    containerNumber: string | null;
    heightMm: number;
    floor: string;
    windowDoorType: string;
    weightKg: number | null;
    weightLbs: number | null;
};

export type PanelListElement = PanelListCommonElement & {
    category: PanelCategory;
    panelType?: string;
    panelId: string;
    type: PanelType;
    side: string | null;
    widthMm?: number;
    widthLMm?: number;
    widthRMm?: number;
    areaM2: number;
};

export type FitToViewPanelListEventPayload = {
    id: string;
    category: PanelCategory;
};
